window.addEventListener('load', initRichtextToTabs);

function initRichtextToTabs() {
  const productTabsContainer = document.querySelector('[data-product_tabs_container]');
  if (!productTabsContainer) return;
  const richtextContainer = productTabsContainer.querySelector('.metafield-rich_text_field');
  if (!richtextContainer) return;

  const tabsOutput = productTabsContainer.querySelector('[data-tabs]');
  const tabTemplate = productTabsContainer.querySelector('[data-tab_template]');
  if (!tabsOutput || !tabTemplate) return;

  let headingIndex = -1;
  const productTabs = [];
  for (const element of richtextContainer.children) {
    if (element.nodeName.toLowerCase() === 'h3') {
      productTabs.push({ header: element.textContent, content: [] });
      headingIndex++;
      continue;
    }
    if (headingIndex < 0) continue;
    productTabs[headingIndex].content.push(element);
  }
  productTabs.forEach((tab, tabIndex) => renderTab(tab, tabTemplate, tabsOutput, tabIndex));

  productTabsContainer.removeChild(richtextContainer);
  productTabsContainer.removeChild(tabTemplate);
  productTabsContainer.classList.remove('[&>*:first-child]:hidden');
}

function renderTab(data, template, target, index) {
  const tab = template.cloneNode(true);
  const header = tab.querySelector('[data-header]');
  const content = tab.querySelector('[data-content]');
  if (!header || !content) return;

  header.textContent = data.header;
  data.content.forEach((element) => content.appendChild(element));

  tab.classList.remove('hidden');
  tab.removeAttribute('data-tab_template');
  header.removeAttribute('data-header');
  content.removeAttribute('data-content');

  addTabEvent(tab);
  const insertBeforeTab = target.querySelector('[data-tabs_insert_before]');
  if (insertBeforeTab) {
    target.insertBefore(tab, insertBeforeTab);
  } else {
    target.appendChild(tab);
  }

  if (index === 0) {
    const headerLabel = tab.querySelector('.accordion-header');
    headerLabel.click();
  }
}

function addTabEvent(tab) {
  const accordionHeader = tab.querySelector('.accordion-header');
  const accordionContent = tab.querySelector('.accordion-content');
  const accordionChevron = tab.querySelector('.accordion-chevron');

  accordionHeader.addEventListener('click', function () {
    const isActive = tab.classList.contains('active');
    const activeTab = tab.parentElement.querySelector('.active');
    if (activeTab) {
      const activeContent = activeTab.querySelector('.accordion-content');
      const activeChevron = activeTab.querySelector('.accordion-chevron');

      activeContent.classList.add('hidden');
      activeChevron.classList.remove('rotate-180');
      activeTab.classList.remove('active');
      if (isActive) return;
    }
    accordionContent.classList.remove('hidden');
    accordionChevron.classList.add('rotate-180');
    tab.classList.add('active');
  });
}
